<template>
  <div>
    <!--云店 -->
    <div v-if="type===0" class="itemBox white" @click="$router.push('/me/order/detail?orderId=' + item.orderId)">
      <div class="top flex space_between f14">
        <span class="gray_f"
              @click="$router.push('/whyd/factory/index?factoryId='+item.factory.id)">{{ item.factory.name }}</span>
        <span class="_app">{{ ydStatus[item.status] }}</span>
      </div>
      <div class="goods flex space_between" v-for="(sItem, i) in item.item" :key="i">
        <div class="left">
          <img :src="sItem.goodsImage" alt=""/>
        </div>
        <div class="right f14">
          <div class="overell">
            <span class="_app_bg _white f12 bold_f" style="padding:1px 2px;"
                  v-if="sItem.isDM==='1'">代买</span>
            <span class="bold_f">{{ sItem.goodsName }}</span>
          </div>
          <div><span class="_app f14">￥{{ sItem.price }}</span></div>
          <div class="flex space_between">
            <div class="sku f12 gray_f">{{ sItem.sku }}</div>
            <span class="f12 gray_f">X{{ sItem.num }}</span>
          </div>
          <div class="flex space_between">
            <div class="f12 gray_f"><span>{{ item.createTime }}</span></div>
            <span class="f12 _tongBan">{{ sItem.tongBan }}铜板</span>
          </div>
        </div>
      </div>
      <div class="bottom f14 flex space_between">
        <div class="left gray_f">总额：<span class="_app">￥{{ item.money }}</span></div>
        <div class="btn">
          <div class="btn_gray" v-if="item.status==='0'"
               @click.stop="$router.push('/me/order/cancel?orderId=' + item.orderId)">
            取消订单
          </div>
          <div class="btn_gray" v-if="(item.status==='1'||item.status==='2') && (item.item[0].isPre==='0')"
               @click.stop="$router.push('/me/order/refundApply?orderId=' + item.orderId + '&total=' +item.money)">
            申请退款
          </div>
          <div class="btn_gray" v-if="item.status==='6'" @click.stop="cancelRefund(item)">取消退款</div>
          <div class="btn_gray" v-if="item.status==='6'"
               @click.stop="$router.push('/me/order/refundDetail?orderId=' + item.orderId)">
            退款中
          </div>
          <div class="btn_gray" v-if="item.status==='7'"
               @click.stop="$router.push('/me/order/refundDetail?orderId=' + item.orderId)">
            已退款
          </div>
          <div class="btn_red" v-if="item.status==='0'"
               @click.stop="$router.push('/common/pay/index?way=order&orderId=' + item.orderId + '&money=' + item.money)">
            去付款
          </div>
          <div class="btn_red" v-if="item.status==='2'" @click.stop="toSign(item)">确认收货</div>
          <div class="btn_red" v-if="item.status==='3'"
               @click.stop="$router.push('/me/order/evaluate?orderId=' + item.orderId)">
            去评价
          </div>
        </div>
      </div>
    </div>
    <!--淘客-->
    <div v-if="type===1" class="itemBox white">
      <div class="top flex space_between f14">
        <div v-if="item.type==='0'">淘宝/天猫</div>
        <div v-if="item.type==='1'">京东</div>
        <div v-if="item.type==='2'">拼多多</div>
        <div class="_app">
          <span v-if="item.status==='-1'">已失效</span>
          <span v-if="item.status==='0'">已付款</span>
          <span v-if="item.status==='1'">已结算</span>
        </div>
      </div>
      <div class="goods space_between">
        <div class="left"><img :src="item.goodsImage" alt=""></div>
        <div class="right f14">
          <div class="overell"><b>{{ item.goodsName }}</b></div>
          <div class="flex space_between">
            <div class="_app">￥{{ item.money }}</div>
            <span class="f12 gray_f">X{{ item.goodsNum }}</span>
          </div>
          <div class="f12 gray_f">付款日：{{ item.payTime }}</div>
          <div class="f12">
            订单号：{{ item.id }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ydOrderRefundCancel, ydOrderSign} from "../api/commonV2";

export default {
  name: 'orderItem',
  props: {
    type: '', //什么类型订单：0云店订单，1淘客订单
    item: Object
  },
  data() {
    return {
      ydStatus: {
        0: '待付款',
        1: '待发货',
        2: '待收货',
        3: '待评价',
        4: '已完成',
        5: '已取消',
        6: '退款/售后'
      }, //云店订单状态
    }
  },
  filters: {},
  created() {
  },
  methods: {
    // 确认收货
    toSign(item) {
      console.log("item=" + JSON.stringify(item))
      this.$dialog.confirm({
        title: '提示',
        message: '确认已经收到货了吗',
        confirmButtonColor: this.m_color
      }).then(() => {
        let data = {
          orderId: item.orderId
        }
        ydOrderSign(data).then(res => {
          if (res.result === '0') {
            this.showToast('已确认收货')
            this.$emit('refresh')
          }
        })
      }).catch(() => {
        this.showToast('已取消')
      })
    },
    // 取消退款
    cancelRefund(item) {
      this.$dialog.confirm({
        title: '提示',
        message: '确定取消退款吗？',
        confirmButtonColor: this.m_color
      }).then(() => {
        let data = {
          orderId: item.orderId
        }
        ydOrderRefundCancel(data).then(res => {
          if (res.result === '0') {
            this.showToast('取消退款成功')
            this.$emit('refresh')
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped lang="less">
.itemBox {
  width: 95%;
  margin: 2% auto 0;
  padding: 0 3%;
  border-radius: 4%;
  text-align: left;

  .top {
    width: 100%;
    line-height: 30px;
    border-bottom: 1px solid #F6F6F6;
  }

  .goods {
    padding: 3% 0;
    display: flex;
    align-items: flex-start;

    .left img {
      width: 100px;
      height: 100px;
      border-radius: 8px;
    }

    .right {
      width: 68%;
      line-height: 1.8;

      .sku {
        display: inline-block;
        background: #f7f7f7;
        padding: 2px 8px;
        margin: 4px 0;
      }
    }

  }

  .bottom {
    border-top: 1px solid #F6F6F6;
    padding: 10px 0;

    .btn {
      display: flex;
      justify-content: flex-end;

      .btn_gray {
        border-radius: 4px;
        border: 1px solid #F0F0F0;
        padding: 2px 8px;
        margin: 0 8px;
        color: gray;
      }

      .btn_red {
        border-radius: 4px;
        border: 1px solid #E61B1B;
        padding: 2px 8px;
        margin: 0 8px;
        color: #E61B1B;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderItem.vue